/**
 * ChatFluent Web Entry Point
 * React Native for Web implementation
 */

// Import web polyfills first
import './src/utils/webPolyfills';

import { AppRegistry, Platform } from 'react-native';
import App from './App';
import appConfig from './app.json';
const appName = appConfig.name;

// Configure React Native Web
if (Platform.OS === 'web') {
  // Configure the app for web
  const rootTag = document.getElementById('root') || document.getElementById('main');
  
  // Register the app
  AppRegistry.registerComponent(appName, () => App);
  
  // Run the app
  AppRegistry.runApplication(appName, {
    rootTag,
    initialProps: {},
  });
} else {
  // Fallback for non-web platforms
  AppRegistry.registerComponent(appName, () => App);
}